// Analytics keys a product by its name, so it has to report the Dutch title
// whatever site the visitor is on - the same reason the order payload carries it
// (see ProductsPreparator::applyPrimarySiteTitles). Products handed out by the
// store carry it as `primaryTitle`; the localized title is the fallback for a
// product the translations endpoint does not know.
const getGtmProduct = (product, i = 0) => ({
  item_id: product.id,
  item_name: product.primaryTitle || product.title,
  currency: 'EUR',
  index: i + 1,
  item_category: product.type,
  item_list_name: document.title,
  item_variant: product.letter,
  // GA4 expects a number; the Price field allows decimals, so no ".00" template.
  price: Number(Number(product.cost ?? 0).toFixed(2)),
  quantity: 1,
});

export default getGtmProduct;
